import { CRS_SURVEY_CODES } from '../../utils/surveyLiterals';
import { CooButtonsSection } from './ButtonsCooSection';
import ButtonsSection from './ButtonsTpsSection';



export default function ButtonSectionFactory(props) {
  switch (props.code) {
    case CRS_SURVEY_CODES.TPS:
    case CRS_SURVEY_CODES.TPSMEX:
      return <ButtonsSection {...props} />;
    case CRS_SURVEY_CODES.COO:
      return <CooButtonsSection {...props} />;
    default:
      return <ButtonsSection {...props} />;
  }
}